module.exports = __webpack_public_path__ + "img/horizontal_7_5_8004.ad83ea79.png";